import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconManager } from '@speeki/icons';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useResponsive } from '@utils/hooks/useResponsive';
import { useServiceRedirect } from '@utils/hooks/useServiceRedirect';
import { useUserLogin } from '@utils/hooks/useUserLogin';

import { getPath } from '@services/RouteService/paths';

import { FormBottomElement } from '@domains/auth/molecules/FormBottomElement/FormBottomElement';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { LoginForm } from '@domains/auth/organisms/LoginForm/LoginForm';

export const LoginDisclosuresPage = () => {
    useServiceRedirect({ path: '/disclosure/list' });
    const { t } = useTranslation();
    const navigate = useNavigate();

    const isSm = useResponsive('sm');

    const { login, sessionProcessing } = useUserLogin();

    return (
        <ColumnsLayout
            breadcrumb={t('LOGIN_DISCLOSURE_TITLE')}
            contentPadding={{
                bottom: 40,
                top: 16,
            }}
            title={isSm ? undefined : t('LOGIN_DISCLOSURE_TITLE')}
        >
            <Card testId="Ahudjmf">
                <Card.TitleTertiary>
                    {t('ALREADY_HAVE_AN_ACCOUNT')}
                </Card.TitleTertiary>
                <Card.Description>
                    {t('NEW_LOGIN_DESCRIPTION')}
                </Card.Description>
                <LoginForm
                    bottomElement={
                        <FormBottomElement
                            buttonText={t('CREATE_AN_ACCOUNT')}
                            onSubmit={() =>
                                navigate(getPath({ path: '/auth/signup' }))
                            }
                        />
                    }
                    handleLoginSubmit={login}
                    loading={sessionProcessing}
                />
            </Card>
            <LoginBanner>
                <IconManager icon={'SvgInfo'} size={16} />
                <LoginBanner.Description>
                    {t('LOGIN_DISCLOSURE_BOX_TEXT')}
                </LoginBanner.Description>
            </LoginBanner>
        </ColumnsLayout>
    );
};
